type Props = {
  legendText: string;
};

const LegendText: React.FC<Props> = ({ legendText }) => {
  return <div className="legend-text">{legendText}</div>;
};
export default LegendText;
